module.exports = __webpack_public_path__ + "static/media/send-grey.4b6df0fe.svg";